// extracted by mini-css-extract-plugin
module.exports = {"root":"EnhancedTableFooter_root__3LNkQ","row":"EnhancedTableFooter_row__1bVPC","cell":"EnhancedTableFooter_cell__236xe","children":"EnhancedTableFooter_children__16bDo"};